var wannasornPermissions = {
  'course':          ['org/admin', 'org/instructor', 'org/course_manager', 'sub_company/admin', 'sub_company/course_manager'],
  'book-management': ['org/admin', 'org/course_manager', 'org/document_officer', 'sub_company/admin', 'sub_company/course_manager'],
  'user':            ['org/admin', 'org/general_staff'],
  'exam':            [],
  'attendance':      ['org/admin', 'org/instructor', 'org/course_manager'],
  'purchase':        ['org/admin', 'org/course_manager', 'org/accountant', 'sub_company/admin', 'sub_company/accountant'],
  'analytics':       ['org/admin', 'org/course_manager', 'org/accountant'],
  'report':          ['org/admin', 'org/instructor', 'org/accountant', 'sub_company/admin', 'sub_company/accountant'],
  'misc':            ['org/admin', 'org/course_manager'],

  'book-delivery':                ['org/admin', 'org/document_officer'],
  'book-pickup':                  ['org/admin', 'org/document_officer'],
  'book-delivery-purchase-report':['org/admin', 'org/document_officer', 'sub_company/admin', 'sub_company/course_manager'],
  'book-delivery-summary-report': ['org/admin', 'org/document_officer', 'sub_company/admin', 'sub_company/course_manager'],

  'course-mgmt':            ['org/admin', 'org/instructor', 'org/course_manager', 'sub_company/admin', 'sub_company/course_manager'],
  'course-tag-mgmt':        ['org/admin'],
  'course-additional-mgmt': ['org/admin'],

  'user-mgmt':                             ['org/admin', 'org/general_staff'],
  'user-group-mgmt':                       ['org/admin'],
  'enroll-mgmt':                           [],
  'admin-mgmt':                            ['org/admin'],
  'abnormal-usage-log':                    ['org/admin', 'org/general_staff'],
  'member-identity-verification':          ['org/admin', 'org/general_staff'],
  'face-verify-overview':                  ['org/admin', 'org/general_staff'],
  'member-face-registration-verification': ['org/admin', 'org/general_staff'],
  'member-face-learning-verification':     ['org/admin', 'org/general_staff'],

  'attendance-summary':       ['org/admin', 'org/instructor', 'org/course_manager'],
  'member-attendance-report': ['org/admin', 'org/instructor', 'org/course_manager'],

  'company-course-extend-price': ['org/admin', 'org/course_manager'],
  'course-order-list':           ['org/admin', 'org/accountant', 'sub_company/admin', 'sub_company/accountant'],
  'course-sales-history-report': ['org/admin', 'org/accountant', 'sub_company/admin', 'sub_company/accountant'],
  'cash-register': ['org/admin'],

  'user-analytics':       ['org/admin'],
  'course-analytics':     ['org/admin', 'org/course_manager'],
  'certificate-overview': ['org/admin'],
  'revenue-analytics':    ['org/admin', 'org/accountant'],

  'trial-course-history-report':    ['org/admin', 'org/instructor'],
  'student-count-by-school-report': ['org/admin', 'org/instructor'],
  'student-course-summary-report':  ['org/admin', 'org/instructor', 'sub_company/admin', 'sub_company/accountant'],
  'learning-history-report':        ['org/admin', 'org/instructor'],
  'tfac-individual-report':         ['org/admin', 'org/instructor'],
  'tfac-enroll-summary-by-course-report':         ['org/admin', 'org/instructor'],

  'carousel-mgmt':  ['org/admin'],
  'resource-usage': ['org/admin'],
};
import { isWannasornCompany } from "@/helpers/wannasorn";

export function checkMenuAccess({ menu }, currentUser) {
  return checkAccessByPriority(menu, currentUser, checkMenuAccessForRoles);
}

export function checkSubMenuAccess({ menu }, currentUser) {
  return checkAccessByPriority(menu, currentUser, checkSubMenuAccessForRoles);
}

function checkAccessByPriority(menu, currentUser, roleBasedAccessFn) {
  if (!currentUser) return false;

  const userRoles = currentUser.roles || [];
  const userComId = currentUser.comId || null;
  const userComType = currentUser.comType || null;
  const mId = currentUser.mId || null;

  // 1. Check specific member rules
  const canSpecificMemberAccess = checkSpecificMemberAccessRule(
    mId,
    userComId,
    menu
  );
  if (canSpecificMemberAccess !== undefined) {
    return canSpecificMemberAccess;
  }

  // 2. Check specific company rules
  const canSpecificCompanyAccess = checkSpecificCompanyAccessRule(
    userComId,
    userRoles,
    menu
  );
  if (canSpecificCompanyAccess !== undefined) {
    return canSpecificCompanyAccess;
  }

  // 3. Check admin role and company type rules
  return roleBasedAccessFn(userRoles, userComId, userComType, menu);
}

function checkSpecificMemberAccessRule(mId, userComId, menu) {
  const tutorrusMember = mId == 283814 && userComId == 408; // tutorrus

  // remark disable spectificMember case for abigcenter for name clickup task id #14zfbg094t6
  const abigMember = [163220, 163221, 296844].includes(mId) && userComId == 277; // abigcenter
  // const hiddenCourseMenuMember =
  //  [122372, 88749, 122380, 84123, 85923, 93996, 182132].includes(mId) &&
  //  userComId == 277;

  // const tfacMember = [301751, 301750].includes(mId) && userComId == 485;

  if (tutorrusMember) {
    if (
      menu === "course" ||
      menu === "exam" ||
      menu === "course-mgmt" ||
      menu === "exam-mgmt"
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (abigMember) {
    if (menu === "purchase" || menu === "cash-register") {
      return true;
    } else {
      return false;
    }
  }

  // if (hiddenCourseMenuMember && menu === "course") {
  //   return false;
  // }

  return undefined;
}

function checkSpecificCompanyAccessRule(userComId, userRoles, menu) {
  const isTutorInstructorRole = hasAnyMatchingRole(
    ["tutor/instructor"],
    userRoles
  );
  const isTutorAdminRole = hasAnyMatchingRole(["tutor/admin"], userRoles);
  const isOrgAdminRole = hasAnyMatchingRole(["org/admin"], userRoles);

  const openCompanyLiveMenu = [
    112, // berante
    180, // tuemaster
    512, // tguru
    408, // tutorrus
    516, // vschool
    277, // abigcenter
    508, // aj.golf
  ].includes(userComId);

  const openAffiliateMenu = [
    3, // coursesquare
    180, // tuemaster
    277, // abig
    512, // tguru
    116, // thailampoon
    508, // ajgolf
    516, // vschool
    527, // theplanner
    524, // pdpc
    525, // dpoaas
  ].includes(userComId);

  const openBannerMenu = [
    3, // coursesquare
    180, // tuemaster
    277, // abig
    512, // tguru
    116, // thailampoon
    508, // ajgolf
    516, // vschool
    527, // theplanner
    528, // socialnock
    524, // pdpc
    525, // dpoaas
    513, // nyc
    519, // dharmniti
    503, // thaire
  ].includes(userComId);

  const isWannasorn = isWannasornCompany(userComId);

  if (
    userComId == 512 &&
    (isTutorInstructorRole || isTutorAdminRole) &&
    (menu === "attendance" ||
      menu === "attendance-summary" ||
      menu === "member-attendance-report")
  ) {
    return true;
  }

  if (userComId == 512) {
    if (menu === 'course-group-mgmt' && (isOrgAdminRole || isTutorAdminRole)) {
      return true;
    }
  }

  if (isWannasorn) {
    if (wannasornPermissions[menu] !== undefined) {
      return hasAnyMatchingRole(wannasornPermissions[menu], userRoles);
    }
    return false;
  }
  
  if (menu === 'learning-face-monitoring') {
    return userComId === 1000001;
  }

  if (
    isWannasorn && 
    (menu === 'member-identity-verification' || 
      menu === "course-additional-mgmt" || 
      menu === 'trial-course-history-report' ||
      menu === 'student-course-summary-report' ||
      menu === 'book-delivery-purchase-report' ||
      menu === 'student-count-by-school-report' ||
      menu === 'learning-history-summary-report' ||
      menu === 'student-info-report' ||
      menu === 'abnormal-usage-log')
  ) {
    return true;
  }

  if (isWannasorn) {
    if (wannasornPermissions[menu] !== undefined) {
      return hasAnyMatchingRole(wannasornPermissions[menu], userRoles);
    }
    return false;
  }

  if (openCompanyLiveMenu && (menu === "live" || menu === "live-mgmt")) {
    return true;
  }

  if (openAffiliateMenu && (menu === "affiliate" || menu === "affiliate-link-mgmt")) {
    return true;
  }

  if (openBannerMenu && (menu === "misc" || menu === "carousel-mgmt")) {
    return !isTutorInstructorRole;
  }

  if (userComId == 503) {
    // thaire
    if (menu === "thaire-completed-courses-report") {
      return isTutorAdminRole;
    }
  }

  if (userComId == 519) {
    // dharmniti
    if (menu === "cash-register" && isTutorAdminRole) {
      return true;
    }

    if (menu === "tfac-completed-enoll-by-date-report") {
      return isTutorAdminRole;
    }
  }

  if (userComId == 485) {
    // tfac
    if (
      menu === "member-face-learning-verification" ||
      menu === "face-verify-overview" ||
      menu === "member-face-registration-verification" ||
      menu === "tfac-completed-enoll-by-date-report"
    ) {
      return isTutorAdminRole;
    }

    if (
      menu === "tfac-overview" ||
      menu === "tfac-revenue-summary-by-course-report"
    ) {
      return isTutorAdminRole || isOrgAdminRole;
    }
  }

  if (userComId == 513) {
    // nycgroup
    if (menu === "nyc-overview") {
      return isTutorAdminRole;
    }
  }

  if ([437, 498, 499].includes(userComId)) {
    // กรุงเทพประกันภัย, HRH, คณะแพทย์ มข.
    if (menu === "export-learning-history-report") {
      return true;
    }
  }

  if (userComId == 277) {
    // abigcenter
    if (menu === "learning-history-report") {
      return true;
    }
  }

  if (userComId == 473) {
    // skl
    if (menu === "exam-detailed-result-report") {
      return true;
    }
  }

  // thaire, trainingplus
  if ([503, 470].includes(userComId) && menu === "course-complete-approval") {
    return true;
  }

  return undefined;
}

function checkMenuAccessForRoles(userRoles, userComId, userComType, menu) {
  const insuranceCompanyIds = [
    470, // trainingplus
    500, // tiba
    502, // rsquare
    503, // thaire
    506, // tqm
  ];
  const accountCompanyIds = [
    485, // tfac
    513, // nycgroup
    519, // dharmniti
  ];

  const isInsuranceType = insuranceCompanyIds.includes(userComId);
  const isAccountType = accountCompanyIds.includes(userComId);
  const isTutorType =
    (userComType == "WHITELABEL_TUTOR" || userComType == "TRAINER") &&
    !accountCompanyIds.includes(userComId);

  const isTutorInstructorRole = hasAnyMatchingRole(
    ["tutor/instructor"],
    userRoles
  );
  const isTutorAdminRole = hasAnyMatchingRole(["tutor/admin"], userRoles);
  const isOrgAdminRole = hasAnyMatchingRole(["org/admin"], userRoles);
  const isOrgInstructorRole = hasAnyMatchingRole(["org/instructor"], userRoles);

  const setRolesMap = {
    course: [
      "org/admin",
      "org/instructor",
      "org/hr",
      "org/group_admin",
      "tutor/admin",
      "tutor/instructor",
      "tutor/content_creator",
    ],
    "book-management": [
      "org/admin",
      "org/instructor",
      "org/hr",
      "org/group_admin",
      "tutor/admin",
      "tutor/instructor",
      "tutor/content_creator",
    ],
    user: [
      "org/admin",
      "org/hr",
      "org/group_admin",
      "org/audit",
      "tutor/admin",
    ],
    exam: [
      "org/admin",
      "org/hr",
      "org/instructor",
      "org/group_admin",
      "tutor/admin",
      "tutor/instructor",
    ],
    courseComplete: [
      "org/admin",
      "org/instructor",
      "tutor/admin",
      "tutor/instructor",
    ],
    purchase: ["tutor/admin", "tutor/instructor"],
    analytics: [
      "org/admin",
      "org/instructor",
      "org/hr",
      "org/audit",
      "org/group_admin",
      "tutor/admin",
      "tutor/instructor",
      "tutor/content_creator",
    ],
    report: [
      "org/hr",
      "org/audit",
      "org/group_admin",
      "org/admin",
      "tutor/admin",
      "tutor/instructor",
      "tutor/content_creator",
    ],
    discussion: [
      "org/admin",
      "org/instructor",
      "org/hr",
      "tutor/admin",
      "tutor/instructor",
    ],
    misc: [
      "org/admin",
      "tutor/admin",
    ]
  };

  const setRoles = setRolesMap[menu];

  if (!setRoles) {
    console.log("No matching menu in setRolesMap");
    return false;
  }

  const hasRole = hasAnyMatchingRole(setRoles, userRoles);

  if (menu === "user") {
    return (
      hasRole &&
      (isAccountType ||
        isTutorType ||
        isOrgAdminRole ||
        isTutorAdminRole ||
        (isInsuranceType && isTutorAdminRole))
    );
  }
  if (menu === "purchase") {
    return hasRole && (isInsuranceType || isAccountType || isTutorType);
  }
  if (menu === "report") {
    return (
      hasRole && !isTutorType || !isInsuranceType && (!isTutorInstructorRole || !isOrgInstructorRole)
    );
  }
  if (menu === "book-management") {
    return (
      hasRole &&
      (isAccountType ||
        isTutorType ||
        isOrgAdminRole ||
        isTutorAdminRole ||
        (isInsuranceType && isTutorAdminRole))
    );
  }
  if (menu === "discussion") {
    return hasRole && !isInsuranceType;
  }
  
  // thaire, trainingplus
  if (menu === "courseComplete") {
    return hasRole && [503, 470].includes(userComId);
  }

  return hasRole;
}

function checkSubMenuAccessForRoles(userRoles, userComId, userComType, menu) {
  const accountCompanyIds = [
    485, // tfac
    513, // nycgroup
    519, // dharmniti
  ];
  const insuranceCompanyIds = [
    470, // trainingplus
    500, // tiba
    502, // rsquare
    503, // thaire
    506, // tqm
  ];
  const isWannasorn = isWannasornCompany(userComId);
  const isAccountType = accountCompanyIds.includes(Number(userComId));
  const isInsuranceType = insuranceCompanyIds.includes(Number(userComId));

  const isTutorType =
    (userComType == "WHITELABEL_TUTOR" || userComType == "TRAINER") &&
    !accountCompanyIds.includes(userComId);

  const isOrgAdminRole = hasAnyMatchingRole(["org/admin"], userRoles);
  const isTutorAdminRole = hasAnyMatchingRole(["tutor/admin"], userRoles);
  const isTutorInstructorRole = hasAnyMatchingRole(
    ["tutor/instructor"],
    userRoles
  );

  if (menu === "course-mgmt") {
    return true;
  }

  if (menu === "course-group-mgmt") {
    return !isTutorType && (isTutorAdminRole || isOrgAdminRole);
  }

  if (menu === "course-video-process-status") {
    return isTutorAdminRole || isOrgAdminRole;
  }

  if (userComId == 1000003 && (menu === "company-course-extend-price")) {
    return true;
  }

  if (menu === "course-tag-mgmt" || menu === "user-mgmt" || menu === "user-group-mgmt" || menu === "enroll-mgmt" || menu === "admin-mgmt") {
    if (isOrgAdminRole || isTutorAdminRole) {
      return true;
    } else {
      return false;
    }
  }

  if (
    menu === "face-verify-overview" ||
    menu === "member-face-registration-verification" ||
    menu === "member-face-learning-verification"
  ) {
    return isInsuranceType && isTutorAdminRole;
  }

  if (
    menu === "exam-mgmt" ||
    menu === "exam-overview" ||
    menu === "exam-answersheet" ||
    menu === "exam-upload"
  ) {
    return true;
  }

  if (menu === "promotion-mgmt" || menu === "coupon-mgmt") {
    return (
      (isInsuranceType || isAccountType || isTutorType) && isTutorAdminRole
    );
  }
  if (menu === "transfer-monet-list") {
    return (
      (isInsuranceType || isTutorType || isAccountType) && isTutorAdminRole
    );
  }
  if (menu === "course-order-list" || menu === "revenue-analytics") {
    return (
      (isTutorAdminRole || isTutorInstructorRole) &&
      (isInsuranceType || isAccountType || isTutorType)
    );
  }
  if (menu === "cash-register") {
    return isTutorType && isTutorAdminRole;
  }

  if (
    menu === "user-analytics" ||
    menu === "course-analytics" ||
    menu === "certificate-overview"
  ) {
    return true;
  }

  if (
    menu === "tfac-purchase-summary-by-course-report" ||
    menu === "tfac-individual-report"
  ) {
    return isAccountType;
  }

  if (menu === "tfac-enroll-summary-by-course-report") {
    return isWannasorn || isAccountType;
  }

  if (menu === "learning-history-report") {
    return (isTutorAdminRole || isOrgAdminRole);
  }

  if (menu === "discussion-mgmt") {
    return !isInsuranceType;
  }

  if (menu === "resource-usage") {
    return isTutorAdminRole || isOrgAdminRole;
  }

  if (menu === "book-management" || menu == 'book-delivery' || menu == 'book-pickup') {
    return true; // Allow all users to access book management
  }

  return false;
}

function hasAnyMatchingRole(setRoles, userRoles) {
  return setRoles.some((r) => userRoles.includes(r));
}
